module.exports = "mutation EditBlogPost($id: ID!, $fields: JSON!) {\n  updateBlogPost(id: $id, fields: $fields) {\n    id\n  }\n}"